<template>

  <div class="comment-content">
    <div class="header">
      <el-date-picker
              v-model="searchTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleSearchInputChange"
              :editable="false"
              clearable
              :picker-options="pickerOptions">
      </el-date-picker>
      <el-select
              v-model="tagValue"
              placeholder="选择标签"
              clearable
              class="search-select"
              @change="handleSearchInputChange">
        <el-option v-for="item in tagOptions" :label="item.label" :value="item.value" :key="item.value + item.label"></el-option>
      </el-select>
      <div class="summary-box">
         <p class="search-tip">
          <span class="info">
              评论：<span class="search-count mr">{{ conditionDiscussionCount }}</span>
              回复：<span class="search-count">{{ conditionRelayCount }}</span>
          </span>
         </p>
         <el-button class="export-btn" plain @click="handleExport" >导出评论</el-button>
      </div>
    </div>
    <div class="table_container">
      <el-table
              :data="tableData"
              ref="listTable"
              :height="tableHeight"
              stripe
              :default-sort="{prop: 'createTime', order: 'descending'}"
              @sort-change="handleTableSortChange"
              :header-row-style="{height:'36px'}"
              :row-style="{height:'36px'}"
              :cell-style="{padding:'0px', textAlign: 'center'}"
              :header-cell-style="tableHeaderStyle"
              style="width: 100%;" >
        <el-table-column
                type="index"
                :index="getIndex"
                label="序号"
                width="80"
        >
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="更新时间"
                sortable="custom"
                :sort-orders="['ascending', 'descending']"
                min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime : '-' }}
          </template>
        </el-table-column>
        <el-table-column
                label="用户"
                min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.username ? scope.row.username : '-' }}
          </template>
        </el-table-column>
        <el-table-column
                label="词条"
                min-width="100"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.terminologyName ? scope.row.terminologyName : '-' }}
          </template>
        </el-table-column>
        <el-table-column
                label="评论/回复"
                min-width="100"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.content ? scope.row.content : '-' }}
          </template>
        </el-table-column>
        <el-table-column
                label="标签"
                min-width="50"
        >
          <template slot-scope="scope">
            {{ scope.row.tag ? scope.row.tag : '-' }}
          </template>
        </el-table-column>
        <el-table-column
                label="操作"
                min-width="100"
        >
          <template slot-scope="scope">
            <el-link icon="el-icon-delete" :underline="false" @click="handleDeleteComment(scope.row)">删除</el-link>
          </template>
        </el-table-column>

      </el-table>
      <div class="pager">
        <el-pagination
                background
                @size-change="handleSearchInputChange"
                @current-change="loadTableData"
                :current-page.sync="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size.sync="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalRowCount" style="text-align: right; margin-top: 5px;">
        </el-pagination>
      </div>

    </div>
  </div>

</template>

<script>
  import dateLib from "@/lib/dateLib";
  import UI from '@/mixins/ui';
  import api from "@/api/commentManageData";
  import dateTimeUtil from '@/lib/dateTimeUtil';


  export default {
    name: 'CommentManage',
    mixins: [UI],
    data() {

      return {
        searchTime: ["2020-01-17", dateLib.toDateString(new Date())],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },

        pageIndex: 1,
        pageSize: 10,
        totalRowCount: 0,
        tableData: [],
        conditionDiscussionCount: '-',
        conditionRelayCount: '-',
        sort: 'desc',

        tagValue: '',
        tagOptions: [
          {
            label: '全部',
            value: 'all',
          },
          {
            label: '新增',
            value: '新增',
          },
          {
            label: '同义词',
            value: '同义词',
          },
          {
            label: '删除',
            value: '删除',
          },
          {
            label: '其他',
            value: '其他',
          },
          {
            label: '无标签',
            value: 'null',
          }
        ],
        tableHeight: 'calc(100% - 53px)'
      }
    },

    methods: {
      async handleExport(){
        try {
          let data = await this.$http.post("/api/discussion/export/token");

          if (!data.success) {
            this.$message.error(data.message);
          } else {
            // this.exportFileUrl = "/api/discussion/file/" + data.data;
            let url = '/api/discussion/file/'+ data.data;
            this.$http({
              method: 'GET',
              url: url,
              timeout: 300000,
              responseType: 'blob',
            }).then((res) => {
              setTimeout(() => {
                let fileName =  dateTimeUtil.format(new Date(), 'YYYYMMDD')+'评论导出';
                this.downloadCreateUrl(res, fileName,'xlsx');
              }, 10);
            }).catch((err) => {
                      console.log('导出err', err);
                    });
          }
        } catch (e) {
          this.$message.error(e.message || e);
        }
      },
      //表格头部样式设置
      tableHeaderStyle({ rowIndex }) {
        if (rowIndex === 0) {
          return `
                    background-color: #F6F6F6;
                    height: 36px!important;
                    font-size: 14px;
                    padding:0px;
                    color:#969696;
                    textAlign: center;
                    `;
        }
      },

      getIndex (index) {
        let no = index + 1;
        return no + (this.pageIndex - 1) * this.pageSize;
      },

      handleSearchInputChange () {
        this.pageIndex = 1;
        this.loadTableData();
      },

      handleTableSortChange ({ order }) {
        this.pageIndex = 1;
        if (order === 'ascending') {
          this.sort = 'asc';
        } else {
          this.sort = 'desc';
        }
        this.loadTableData();
      },

      handleDeleteComment (curRow) {
        let msg = '';
        if (curRow.relay) {
          msg = `
            <div class="delete-comment-box__alert">
                <div class="comment-box__alert-first-line">
                  <i class="el-icon-warning-outline"></i>
                  <p class="delete-comment-title">确定删除此条回复吗？</p>
                </div>
                <p class="delete-comment-note">此回复下的所有回复也会同步删除</p>
            </div>
        `;
        } else {
          msg = `
            <div class="delete-comment-box__alert">
                <div class="comment-box__alert-first-line">
                  <i class="el-icon-warning-outline"></i>
                  <p class="delete-comment-title">确定删除此条评论吗？</p>
                </div>
                <p class="delete-comment-note">此评论下的回复也会同步删除</p>
            </div>
        `;
        }
        let options = {
          isCustom: true,
          title: '',
          doConfirm: async () => {
            await api.deleteComment(curRow.id);
            this.loadTableData();
          },
        };
        this.alert(msg, options);
      },

      loadTableData () {
        // 有滚动条情况下，翻页后自动滚动到顶部
        this.$nextTick(() => {
          this.$refs.listTable.bodyWrapper.scrollTop = 0;
        });
        this.loadingData('.comment-content', async () => {
          let tags = null;
          if (!this.tagValue || this.tagValue == 'all') {
            tags = null;
          } else if (this.tagValue == 'null') {
            tags = [null];
          } else {
            tags = [this.tagValue];
          }
          let searchConditions = {
            begin: this.searchTime ? this.searchTime[0] : null,
            end: this.searchTime ? this.searchTime[1] : null,
            tags,
          };
          let res = await api.findCommentList(this.pageIndex, this.pageSize, this.sort, searchConditions);
          if (res && res.data) {
            this.tableData = res.data;
            this.totalRowCount = res.totalRowCount;
            this.conditionDiscussionCount = res.conditionDiscussionCount;
            this.conditionRelayCount = res.conditionRelayCount;
            this.pageIndex = res.pageIndex;
            this.pageSize = res.pageSize;
          }
        });
      },

    },

    beforeRouteEnter (to, from, next) {
      let role = sessionStorage.getItem('-_role_-');
      if (!role || role !== 'admin') {
        next({path: '/home'});
      } else {
        next();
      }
    },

    created() {

    },

    mounted() {
      this.loadTableData();
    }
  }
</script>

<style scoped lang="less">
  .comment-content {
    background-color: #fff;
    padding: 10px 10px 30px;
    height: 100%;
    box-sizing: border-box;
    .mr{
      margin-right: 20px;
    }

    .header {
      padding-top: 8px;
      // height: 46px;

      .search-select {
        width: 150px;
        height: 24px;
        font-size:12px;
        line-height:12px;
        font-weight:400;
        color:rgba(51,51,51,1);
        margin-left: 25px;
      }
      .summary-box {
        display: flex;
        align-items: center;
        margin-top: 22px;
        margin-bottom: 15px;
        color: #333333;
        font-size: 14px;
        .search-tip {
          margin: 0;
          padding: 0;
          .info {
            span {
              color: red;
            }
          }
        }
        .export-btn {
          margin-left: auto;
        }
      }
    }
    .table_container {
      height: calc(100% - 78px);
    }
    .pager{
      margin-top: 10px;
    }

    .export-btn {
      width: 110px;
      height: 24px;
      padding: 0 5px;
      float: right;
      background: white;
      color: #1DAABA;
      border: 1px solid #1DAABA;
    }

    .export-btn:after {
      content: '';
      clear: both;
    }

  }
</style>

<style lang="less">
  .el-date-table td.end-date span, .el-date-table td.start-date span {
    background-color: #68BEBC;
  }
  .el-select-dropdown__item.selected {
    color: #1DAABA;
  }
  .comment-content {
    .el-input__inner{
      height: 24px;
      line-height: 24px;
    }
    .el-input__icon{
      line-height: 18px;
    }
    .el-table td, .el-table th.is-leaf {
      border-bottom: 0px solid #EBEEF5;
    }
    .el-table::before {
      height: 0px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1DAABA;
    }

    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #1DAABA;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
      color: #FFF;
    }

    .el-date-editor .el-range-input, .el-date-editor .el-range-separator {
      font-size: 12px;
    }
    .el-date-editor .el-range-separator {
      line-height: 16px;
    }
    .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
      width: 230px;
    }
    .el-date-editor .el-range__icon {
      font-size: 12px;
    }

    .table_container {
      .el-link,
      .el-link.el-link--default:hover {
        color: #1DAABA;
      }

      .el-table .ascending .sort-caret.ascending {
        border-bottom-color: #1DAABA;
      }

      .el-table .descending .sort-caret.descending {
        border-top-color: #1DAABA;
      }
    }
  }

  .el-tooltip__popper{
    max-width: 20%;
  }

  .delete-comment-box__alert {
    margin-left: 10px;

    p {
      padding: 0;
      margin: 0;
    }

    .comment-box__alert-first-line {
      display: flex;
      align-items: center;

      i.el-icon-warning-outline {
        font-size: 45px;
        color: #FC0D21;
        display: block;
      }

      p.delete-comment-title,
      p.delete-reply-title {
        margin-left: 20px;
        font-weight:500;
        font-size: 16px;
        line-height: 16px;
        color: #333333;
      }

      p.delete-reply-title {
        font-size: 14px;
        line-height: 14px;
      }
    }

    p.delete-comment-note {
      font-size: 14px;
      font-weight: 400;
      color: #969696;
      line-height: 28px;
      margin-left: 65px;
      margin-bottom: 10px;
    }

  }
</style>
